import React from 'react';
import Chart from 'react-apexcharts'
import Utils from '../../providers/Utils';


export default class ChartsMonitorizare extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            viewChart: true,
            series:

                this.props.aplicatii.map((r, idx) => {
                    return { name: r.label, data:r.data , colors:r.data_colors}
                })

            ,
            options: {
                chart: {
                    // height: 350,
                    width: '90%',
                    
                    type: 'bar',
                    toolbar: {
                        show: false,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: false,
                            selection: true,

                        }
                    },


                },

                // colors:[function({ value,seriesIndex, w }) {
          
                //     // console.log('w :>> ', w);
                //     // return ('red')
                //   }] ,
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        dataLabels: {
                            position: 'bottom', // top, center, bottom
                        },
                        borderRadius: 8,
                        columnWidth: '50%',
                        endingShape: "rounded",
                        colors: {
                            backgroundBarColors:this.props.aplicatii.map((r,idx)=>{return r.data_colors}),
                            backgroundBarOpacity: 0,
                            backgroundBarRadius: 0,
                        }
                    }
                },
                legend: {
                    show: false
                },
                stroke: {
                    show: true,
                    width: 1,
                    // colors: ["transparent"]
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, idx, w) {
                        // console.log('idx :>> ', idx.w);
                        // console.log('valDataLabels :>> ', val);

                        



                        // console.log('idx :>> ', idx);
                     

                    },
                    offsetY: 5,
                    floating: true,
                    style: {
                        fontSize: '9px',
                        colors: ["#ffffff"]
                    }
                },
               



                xaxis: {
                    categories: this.props.ore.map((a,idx)=>{return a}),
                    labels: {
                        offsetX: 0,
                        offsetY: 0,
                    },
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: false,
                    },
                    lines: {
                        show: true,
                    }

                },

                grid: {
                    yaxis: {
                        lines: {
                            show: true,
                        }
                    },
                    xaxis: {
                        lines: {
                            show: true,
                        }
                    },
                  margin:{
                      left:0,
                      rigth:0
                  }
                },
                yaxis: {
                    min: 0,
                    axisBorder: {
                        show: true
                    },
                    axisTicks: {
                        show: true,
                    },
                    labels: {
                        show: true,
                        formatter: function (val, idx) {

                            // console.log('idx dataLabel :>> ', idx);
                            // console.log('val :>> ', val);


                            return Math.ceil(val) + 'min'

                        }
                    },


                },
                title: {
                    text: 'Monthly Inflation in Argentina, 2002',
                    floating: true,
                    offsetY: - 50,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            },

        }
    }

    u = new Utils()



    viewChart = true








    render() {

        // console.log('this.props.aplicatii :>> ', this.props.aplicatii);
        return (
     

            <div style={{ background: 'white', width: '100%', overflowX: 'scroll', overflowY:'hidden' }} id="chart" className='scroll-detaliu'>


                <Chart
                    style={{ margin: 'auto' }}
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    // width={1000}
                    height={400}
                />


            </div>


        );
    }
}